module.exports = __webpack_public_path__ + "static/desktop/img/material-mobile-calendar.d0ad38c5.png";